import {ACTIVE_USER_ACTIONS, ActiveUserState} from "./types";
import {ActiveUserInterface} from "./interface";

const initialState: ActiveUserState = {
    activeUserToken: '',
    activeUserEmail: '',
    activeUserIsValid: false,
    activeUserData: {
        name: '',
        email: '',
        confirm: false,
        languages: [],
    },
};

const activeUserReducer = (
    state: ActiveUserState | undefined,
    action: ActiveUserInterface
): ActiveUserState => {

    if (typeof state === 'undefined') {
        state = initialState;
    }

    switch (action.type) {
        case ACTIVE_USER_ACTIONS.setActiveToken:
            return {
                ...state,
                activeUserToken: action.payload
            };
        case ACTIVE_USER_ACTIONS.setUserIsValid:
            return {
              ...state,
              activeUserIsValid: action.payload
            };
        case ACTIVE_USER_ACTIONS.setEmail:
            return {
                ...state,
                activeUserEmail: action.payload
            }
        case ACTIVE_USER_ACTIONS.setUserData:
            return {
                ...state,
                activeUserData: action.payload
            };
        case ACTIVE_USER_ACTIONS.clearData:
            return {
                ... initialState
            }
        default:
            return state;
    }
};

export { activeUserReducer };

